import { MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { Text } from 'bones/components/atoms/Text';

export interface NoResultsMenuItemProps {
  text?: string;
}

export const NoResultsMenuItem: React.VFC<NoResultsMenuItemProps> = ({
  text = 'No Results',
}) => (
  <MenuItem
    className="sd-menu-item-no-results"
    disabled
    text={<Text ellipsize>{text}</Text>}
  />
);
